<template>
    <div class="lookup-container" style="display: flex;">
        <party-reference
        :value="value"
        @input="emitParty($event)"
        ></party-reference>
    </div>
</template>
<script>
import axios from 'axios'
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;

import PartyReference from './PartyReference.vue';

export default {
    props: ['value'],
    components: {
        PartyReference
    },
    methods: {
        emitParty($event) {            
            this.$emit('input', $event);            
        }
    }
}
</script>